import { render } from "./App.vue?vue&type=template&id=7f00c23c&bindings={\"getAppToken\":\"options\",\"addTokenToLocalStorage\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script